.dark {
  color: black;
  &:hover {
    color: white;
  }
}
